import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";

export default function About() {
  const { t } = useLang();
  const chapters = [
    { num: "01", title: t("about_ch1_title"), body: t("about_ch1_body") },
    { num: "02", title: t("about_ch2_title"), body: t("about_ch2_body") },
    { num: "03", title: t("about_ch3_title"), body: t("about_ch3_body") },
  ];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-white text-slate-600 px-6 md:px-12 lg:px-24 py-20 lg:py-32"
    >
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <p className="text-xs tracking-[0.25em] uppercase text-[#ED1C24] mb-4">
                {t("about_label")}
              </p>
              <h2 className="font-display font-semibold text-slate-900 text-4xl sm:text-5xl leading-tight tracking-tight">
                {t("about_title1")}
                <br />
                {t("about_title2")}
                <br />
                {t("about_title3").replace(".", "")}<span className="text-[#ED1C24]">.</span>
              </h2>
              <div className="w-16 h-1 bg-gradient-to-r from-[#ED1C24] to-[#FFC61A] mt-8" />
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8 space-y-0">
          {chapters.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div
                data-testid={`about-chapter-${c.num}`}
                className="group border-t border-slate-200 py-10 grid sm:grid-cols-12 gap-6 items-start hover:bg-slate-50 transition-colors duration-500 px-2 -mx-2"
              >
                <span className="sm:col-span-2 font-display text-5xl font-semibold text-stroke-red group-hover:text-[#ED1C24] group-hover:[-webkit-text-stroke:0] transition-all duration-500">
                  {c.num}
                </span>
                <div className="sm:col-span-10">
                  <h3 className="font-display font-semibold text-slate-900 text-2xl sm:text-3xl mb-4">
                    {c.title}
                  </h3>
                  <p className="text-base lg:text-lg leading-relaxed">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-slate-200" />
        </div>
      </div>
    </section>
  );
}
